import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Tooltip, IconButton, Fab } from '@material-ui/core';
import Api from '../../api/Api.js';
import { store } from '../../redux/store';
import { SET_FTP_LIST } from '../../redux/types';
import DataTable from '../../components/Table/DataTable';
import ReportEndpoints from '../../api/ReportEndpoints';
import moment from 'moment';
import { Edit, List, Add } from '@material-ui/icons';
import { Link } from 'react-router-dom';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Server Name",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Host",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Last Successful Login",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Reports Managed",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: 'Actions',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false
        }
    },
];

class FtpMain extends Component {
    UNSAFE_componentWillMount() {
        Api.get(ReportEndpoints.ftpList).then(({ data }) => store.dispatch({ type: SET_FTP_LIST, payload: data })).catch((e) => console.error(e));
    }

    render() {
        return (
            <>
            <div style={{ minHeight: 40 }}>
                <Fab style={{ float: 'right' }} variant="extended" color="primary" component={Link} to={`/reports/ftpAdd`} >
                    <Add /> Add FTP Server
                </Fab>
            </div>
            <DataTable
                title={"FTP Servers"}
                data={this.props.ftps.map(
                    ftp => [
                        ftp.id,
                        ftp.name,
                        ftp.protocol.toLowerCase() + "://" + ftp.host + ":" + ftp.port,
                        moment(ftp.last_login).format("DD/MM/YYYY @ HH:mm") || 'Never',
                        ftp.reports.length,
                        [
                            <Tooltip key="edit" title="Edit" placement="top">
                                <IconButton color="primary" component={Link} to={`/reports/ftpEdit/${ftp.id}`}>
                                    <Edit />
                                </IconButton>
                            </Tooltip>,
                            <Tooltip key="reports" title="Reports to FTP" placement="top">
                                <IconButton color="secondary" component={Link} to={`/reports/ftpReports/${ftp.id}`}>
                                    <List />
                                </IconButton>
                            </Tooltip>
                        ]
                    ]
                )}
                columns={columns}
            />
            </>
            
        );
    }
}

const mapStateToProps = (state) => ({ ftps: state.reports.ftps })

export default connect(mapStateToProps)(FtpMain);